import Accordion from '@/common/components/Accordion'
import SelectController from '@/common/components/SelectController'
import { usePrinterMachines } from '@/common/hooks/queries/usePrinterMachines'
import useDebounce from '@/common/hooks/useDebounce'
import { Mapper } from '@/common/services/mapper'
import { PrinterMachineData } from '@/common/types/printerMachine.type'
import { PrivateCompanyLeadsFunnelUpdateValidationSchema } from '@/features/privateCompanyLeadsFunnel/schemas/update.schema'
import { BaseSyntheticEvent } from 'react'
import { Control, FieldErrors } from 'react-hook-form'

interface PrinterMachineInformationSectionProps {
  printerMachine?: PrinterMachineData
  control: Control<PrivateCompanyLeadsFunnelUpdateValidationSchema, any>
  errors: FieldErrors<PrivateCompanyLeadsFunnelUpdateValidationSchema>
  submit?: (e?: BaseSyntheticEvent) => Promise<void>
  disabled?: boolean
}

export const PrinterMachineInformationSection = ({
  printerMachine,
  control,
  errors,
  submit,
  disabled,
}: PrinterMachineInformationSectionProps) => {
  const [searchPrinterMachine, setSearchPrinterMachine] = useDebounce('')

  const { data: printerMachines } = usePrinterMachines({
    filters: {
      search: searchPrinterMachine,
    },
    mapper: Mapper.mapToOptions<PrinterMachineData>({ labelFieldName: 'display_name', valueFieldName: 'id' }),
  })

  return (
    <Accordion
      className="py-1"
      contentClassName="overflow-visible"
      defaultOpen
      head={
        <p>
          Detalhes para impressão de cartão <span className="text-danger-soft"> *</span>
        </p>
      }
      body={
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="printer_machine_id"
            label="Impressora padrão de cartões"
            triggerOnChange={submit}
            isDisabled={disabled}
            options={printerMachines}
            defaultValue={printerMachine ? { label: printerMachine.display_name, value: printerMachine.id } : undefined}
            onInputChange={setSearchPrinterMachine}
            errorMessage={errors?.printer_machine_id?.message}
          />
        </div>
      }
    />
  )
}
